import React, { useContext } from 'react';
import Navbar from '../Items/Navbar';
import HomeDashboard from '../home/HomeDashboard';
import PageMeta from '../seo/PageMeta';
import AuthContext from '../shared/AuthContext';
import { STUDY_HUB } from '../../config/appLabels';

const DashboardPage = () => {
  const { user } = useContext(AuthContext);
  const userProfile = user || JSON.parse(localStorage.getItem('userProfile') || 'null');

  return (
    <div className="study-hub-page study-hub-page--v3">
      <PageMeta title={STUDY_HUB.name} description={`${STUDY_HUB.tagline} Progress, review queue, and recommendations.`} />
      <Navbar userProfile={userProfile} loading={false} />
      <div className="app-page-shell home-page-shell">
        <HomeDashboard />
      </div>
    </div>
  );
};

export default DashboardPage;
